define('atendimentos-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function() {
    var app = angular.module('atendimentos.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
    app.factory('Atendimentos', ['$q', '$http', '$location', '$state', 'i18n', 'appRoute', 'notify',
        function($q, $http, $location, $state, i18n, appRoute, notify, $multipart) {
            return {

                create: function(data) {
                    return $q(function(resolve, reject) {
                        return $http.post(appRoute.linkTo('atendimentos.create'), data).success(function(data) {
                            resolve(data);
                        }).error(function(error) {
                            reject(error);
                        });
                    });
                },
                // getUploadsAtendimento
                successUploadImgAtendimento: function(data) {
                    return $q(function(resolve, reject) {
                        return $http.post(appRoute.linkTo('atendimentos.successUploadImgAtendimento'), data).success(function(data) {
                            resolve(data);
                        }).error(function(error) {
                            reject(error);
                        });
                    });
                },
                getUploadsAtendimento: function(data) {
                    return $q(function(resolve, reject) {
                        return $http.get(appRoute.linkTo('atendimentos.getUploadsAtendimento',data.ato_codigo)).success(function(data) {
                            resolve(data);
                        }).error(function(error) {
                            reject(error);
                        });
                    });
                }
            }
        }
    ]);
});
